import {
  renderStatus,
} from "../../../../../Utils/CommonUtils";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useUserColumns = () => {
  const dispatch = useDispatch();
  const usersColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/team/user/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 100,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Created Date",
    //   accessorKey: "created_date",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    {
      header: "Contact Number",
      accessorKey: "contact",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Email",
      accessorKey: "email_id",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Role",
      accessorKey: "role_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Contact Person",
    //   accessorKey: "",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    // {
    //   header: "Contact Number",
    //   accessorKey: "no.",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },

    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    // {
    //   header: "Action",
    //   accessorKey: "action",
    //   cell: (props) => (
    //     <div className="action-icons text-center">
    //       <span
    //         // className="btn btn-sm btn-soft-info edit-list"
    //         onClick={() => {
    //           dispatch(openModal(true));
    //           dispatch(editModal(true));
    //           dispatch(updateRendererFormState(props?.row?.original));
    //           dispatch(setUserEditID(props?.row?.original?.entityid));
    //           // dispatch(setUserEditCode(props?.row?.code));
    //         }}
    //       >
    //         {/* <i className="ri-pencil-fill align-bottom" /> */}
    //         <EditListIcon />
    //       </span>
    //     </div>
    //   ),
    //   meta: { align: "center" },
    //   size: 100,
    // },
  ];

  return { usersColumns };
};

export default useUserColumns;
